/**
 * Created by Claude on 04.02.2026
 */

class AisensiaMissionWindowController extends ScriptComponent {
    onCreate() {
        this.bus = new cleverapps.EventEmitter();

        this.mission = this.options.mission;
        this.closeWindowCallback = this.options.closeWindowCallback;

        this.mission.logEvent(Mission.EVENTS.MISSION_WINDOW);
    }

    getMission() {
        return this.mission;
    }

    getOptions() {
        return this.options;
    }

    getType() {
        return this.mission.type;
    }

    getName() {
        return this.mission.getName();
    }

    getTable() {
        return this.mission.runningCompetition.table;
    }

    getPrize() {
        return this.mission.getPrize();
    }

    isRunning() {
        return this.mission.isRunning();
    }

    getTimeLeft() {
        let timeLeft = this.mission.getTimeLeft();
        if (this.mission.logic.competitionTimeLeft) {
            timeLeft = this.mission.logic.competitionTimeLeft();
        }
        return timeLeft;
    }

    getBundleName() {
        return this.mission.bundle || "mission_window";
    }

    onShow() {
        this.mission.runningCompetition.table.showUp(() => {
            this.mission.runningCompetition.table.updateAll();
        });

        this.bus.trigger("show");
    }

    onHide() {
        this.bus.trigger("hide");
    }

    onClose() {
        if (this.mission.runningCompetition) {
            this.mission.runningCompetition.updateShownPlace();
        }

        if (this.mission.type === Mission.TYPE_LIGHTNING_RUSH) {
            this.mission.logic.receivePrize();
        }

        this.mission.updateMissionIcon();
    }
}
